import { render, staticRenderFns } from "./OnboardingSettingsModal.vue?vue&type=template&id=6826846c&scoped=true&"
import script from "./OnboardingSettingsModal.vue?vue&type=script&lang=js&"
export * from "./OnboardingSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingSettingsModal.vue?vue&type=style&index=0&id=6826846c&prod&lang=scss&"
import style1 from "./OnboardingSettingsModal.vue?vue&type=style&index=1&id=6826846c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6826846c",
  null
  
)

export default component.exports